export const SHOW_PROCESS_STATEMENT_COMMENTS_REQUEST = 'SHOW_PROCESS_STATEMENT_COMMENTS_REQUEST';

export const showProcessStatementCommentsRequest = (processStatementId) => ({
  type   : SHOW_PROCESS_STATEMENT_COMMENTS_REQUEST,
  payload: {
    processStatementId,
  }
});
